module.exports = __webpack_public_path__ + "static/media/cheeseburger.a1b23d16.svg";